import React, { Component } from 'react';
import { HorizontalLine } from './HorizontalLine';
import Cookies from 'universal-cookie';

export class WebsitesManagement extends React.Component {
    state = {
        websites: [],
        loading: true,
        error: null
    }

    constructor(props) {
        super(props);
        this.cookies = new Cookies();
    }

    componentDidMount() {
        this.fetchWebsites();
    }

    fetchWebsites = async () => {
        try {
            const token = this.cookies.get('clickanti_token');
            
            if (!token) {
                this.setState({ 
                    error: 'Токен авторизации не найден',
                    loading: false 
                });
                return;
            }

            const response = await fetch('https://api.clickanti.ru/api/clickanti/websites', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`Ошибка загрузки: ${response.status}`);
            }

            const data = await response.json();
            this.setState({ 
                websites: data,
                loading: false 
            });
        } catch (error) {
            console.error('Ошибка при загрузке сайтов:', error);
            this.setState({ 
                error: error.message,
                loading: false 
            });
        }
    }

    formatNumber = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    getStatusColor = (status) => {
        switch(status) {
            case 'active': return '#39b339';
            case 'inactive': return '#ff9900';
            default: return '#9197B3';
        }
    }

    getStatusText = (status) => {
        switch(status) {
            case 'active': return 'Активен';
            case 'inactive': return 'Неактивен';
            default: return 'Ошибка';
        }
    }

    navigateToIntegrations = (websiteId) => {
        console.log('Переход к интеграциям для сайта:', websiteId);
        // Здесь будет навигация к странице интеграций
    }

    navigateToStats = (websiteId) => {
        console.log('Переход к статистике для сайта:', websiteId);
        // Здесь будет навигация к странице статистики
    }

    toggleProtection = async (websiteId, currentStatus) => {
        try {
            const token = this.cookies.get('clickanti_token');
            
            const response = await fetch(`https://api.clickanti.ru/api/clickanti/websites/${websiteId}/toggle/`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
                
            });

            if (!response.ok) {
                throw new Error('Ошибка при изменении статуса');
            }

            // Обновляем данные после успешного изменения
            await this.fetchWebsites();
        } catch (error) {
            console.error('Ошибка при изменении защиты:', error);
            alert('Не удалось изменить статус защиты');
        }
    }

    renderWebsiteCard = (website) => {
        const tariff = website.tariff_info;
        
        return (
            <div key={website.id} className='pages_pagesBlock_pageBlock' style={{marginBottom: '3em'}}>
                <div className='pages_pagesBlock_pageBlock_name'>
                    <span style={{fontSize: '1.2em', fontWeight: '600'}}>{website.url}</span>
                </div>
                
                <div className='pages_pagesBlock_pageBlock_statsBlock'>
                    <div className='pages_pagesBlock_pageBlock_statsBlock_item'>
                        <div className='pages_pagesBlock_pageBlock_statsBlock_item_row1'>
                            <span>Максимум визитов/месяц</span>
                        </div>
                        <div className='pages_pagesBlock_pageBlock_statsBlock_item_row3'>
                            <strong>{this.formatNumber(website.monthly_visits)}</strong>
                        </div>
                    </div>
                    
                    <div className='pages_pagesBlock_pageBlock_statsBlock_item'>
                        <div className='pages_pagesBlock_pageBlock_statsBlock_item_row1'>
                            <span>Статус</span>
                        </div>
                        <div className='pages_pagesBlock_pageBlock_statsBlock_item_row3' 
                             style={{color: this.getStatusColor(website.is_active ? 'active' : 'inactive')}}>
                            <strong>{this.getStatusText(website.is_active ? 'active' : 'inactive')}</strong>
                        </div>
                    </div>
                    
                    <div className='pages_pagesBlock_pageBlock_statsBlock_item'>
                        <div className='pages_pagesBlock_pageBlock_statsBlock_item_row1'>
                            <span>Защита</span>
                        </div>
                        <div className='pages_pagesBlock_pageBlock_statsBlock_item_row3' 
                             style={{color: website.is_active ? '#39b339' : '#ff3333'}}>
                            <strong>{website.is_active ? 'Вкл' : 'Выкл'}</strong>
                        </div>
                    </div>
                </div>
                
                {/* Информация о тарифе */}
                <div className='pages_pagesBlock_pageBlock_statsBlock'>
                    {tariff ? (
                        <>
                            <div className='pages_pagesBlock_pageBlock_statsBlock_item'>
                                <div className='pages_pagesBlock_pageBlock_statsBlock_item_row1'>
                                    <span>Тариф</span>
                                </div>
                                <div className='pages_pagesBlock_pageBlock_statsBlock_item_row3'>
                                    <strong>{tariff.name}</strong>
                                </div>
                            </div>
                            
                            <div className='pages_pagesBlock_pageBlock_statsBlock_item'>
                                <div className='pages_pagesBlock_pageBlock_statsBlock_item_row1'>
                                    <span>Использовано визитов</span>
                                </div>
                                <div className='pages_pagesBlock_pageBlock_statsBlock_item_row3'>
                                    <strong>{this.formatNumber(tariff.visits_used)} / {this.formatNumber(tariff.visits_limit)}</strong>
                                </div>
                            </div>
                            
                            <div className='pages_pagesBlock_pageBlock_statsBlock_item'>
                                <div className='pages_pagesBlock_pageBlock_statsBlock_item_row1'>
                                    <span>Осталось дней</span>
                                </div>
                                <div className='pages_pagesBlock_pageBlock_statsBlock_item_row3'>
                                    <strong>{tariff.remaining_days}</strong>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className='pages_pagesBlock_pageBlock_statsBlock_item'>
                                <div className='pages_pagesBlock_pageBlock_statsBlock_item_row1'>
                                    <span>Тариф</span>
                                </div>
                                <div className='pages_pagesBlock_pageBlock_statsBlock_item_row3' style={{color: '#ff9900'}}>
                                    <strong>Не подключен</strong>
                                </div>
                            </div>
                            
                            <div className='pages_pagesBlock_pageBlock_statsBlock_item'>
                                <div className='pages_pagesBlock_pageBlock_statsBlock_item_row1'>
                                    <span>Использовано визитов</span>
                                </div>
                                <div className='pages_pagesBlock_pageBlock_statsBlock_item_row3'>
                                    <strong>—</strong>
                                </div>
                            </div>
                            
                            <div className='pages_pagesBlock_pageBlock_statsBlock_item'>
                                <div className='pages_pagesBlock_pageBlock_statsBlock_item_row1'>
                                    <span>Осталось дней</span>
                                </div>
                                <div className='pages_pagesBlock_pageBlock_statsBlock_item_row3'>
                                    <strong>—</strong>
                                </div>
                            </div>
                        </>
                    )}
                </div>
                
                <div className='pages_pagesBlock_pageBlock_btn_row1'>
                    <a href={`/integrations/${website.id}`}>
Интеграции
</a>
                    <a href={`/stats/${website.id}`} 
   
   style={{background: 'linear-gradient(88.2deg, #0767F4 2.97%, #0767F4 2.98%, #30D1E0 110.58%)'}}>
Статистика
</a>
                </div>
                
                {/* Только кнопка управления защитой с отступами */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '1.5em',
                    padding: '0 1.5em 1.5em 1.5em'
                }}>
                    <button 
                        onClick={() => this.toggleProtection(website.id, website.is_active)}
                        style={{
                            padding: '0.6em 1.5em',
                            border: 'none',
                            borderRadius: '0.4em',
                            background: website.is_active ? '#ff3333' : '#39b339',
                            color: 'white',
                            cursor: 'pointer',
                            fontSize: '0.9em',
                            fontWeight: '500',
                            minWidth: '12em',
                            transition: 'all 0.3s',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}
                        onMouseOver={(e) => e.target.style.opacity = '0.9'}
                        onMouseOut={(e) => e.target.style.opacity = '1'}
                    >
                        {website.is_active ? '🛡 Выключить защиту' : '🛡 Включить защиту'}
                    </button>
                </div>
            </div>
        );
    }

    render() {
        const { websites, loading, error } = this.state;
        
        if (loading) {
            return (
                <div className='createPage' style={{paddingBottom: '4em'}}>
                    <h1>Управление сайтами</h1>
                    <HorizontalLine />
                    <div style={{textAlign: 'center', padding: '3em'}}>
                        <p>Загрузка...</p>
                    </div>
                </div>
            );
        }
        
        if (error) {
            return (
                <div className='createPage' style={{paddingBottom: '4em'}}>
                    <h1>Управление сайтами</h1>
                    <HorizontalLine />
                    <div style={{textAlign: 'center', padding: '3em', color: '#ff3333'}}>
                        <p>Ошибка: {error}</p>
                    </div>
                </div>
            );
        }
        
        return (
            <div className='createPage' style={{paddingBottom: '4em'}}>
                <h1>Управление сайтами</h1>
                <HorizontalLine />
                
                <div className='pages_pagesBlock' style={{paddingBottom: '3em'}}>
                    {websites.length > 0 ? (
                        websites.map(website => this.renderWebsiteCard(website))
                    ) : (
                        <h3 className='notCreatedText'>Нет добавленных сайтов</h3>
                    )}
                </div>
            </div>
        );
    }
}